import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CustomerService } from 'gung-standard';
import { first } from 'rxjs';
import { CultDashboardDataService } from '../../services/cult-dashboard-data.service';

@Component({
    selector: 'cult-cult-salesperson-select',
    templateUrl: './cult-salesperson-select.component.html',
    styleUrls: ['./cult-salesperson-select.component.scss'],
    standalone: false
})
export class CultSalespersonSelectComponent implements OnInit {
  myFormGroup: any;
  saljare: string;
  saljareToCustomerIds: any;
  constructor(
    protected dashboardDataService: CultDashboardDataService,
    protected customerService: CustomerService,
    protected formBuilder: FormBuilder
  ) {
    this.saljare = dashboardDataService.selectedSalesPerson;
    this.saljareToCustomerIds = {};

    this.customerService
      .getCustomers()
      .pipe(first())
      .subscribe(customers => {
        customers.forEach(e => {
          const saljare = e.extra.kus.saljare;
          this.saljareToCustomerIds[saljare] = this.saljareToCustomerIds[saljare] || [];
          this.saljareToCustomerIds[saljare].push(e.id);
        });
        this.saljareToCustomerIds.ANÅH = ['1543'];
      });
  }

  ngOnInit(): void {
    this.myFormGroup = this.formBuilder.group({
      saljare: [{ disabled: false, value: this.saljare || '' }]
    });
  }

  salesPersonSelected(event) {
    let filter = null;
    this.dashboardDataService.selectedSalesPerson = event;
    if (event) {
      const salesPersonId = event;
      const customerIds = this.saljareToCustomerIds[salesPersonId];
      if (customerIds) {
        filter = { required: { customerId: customerIds }, salesPersonId };
      } else {
        filter = { required: { customerId: [] }, salesPersonId };
      }
    }

    this.dashboardDataService.setFilter(filter);
  }
}
